import { ICartCouponData, ICartSuggestedCoupon, ICartSuggestedCouponOption } from "~/types/cart";
import { IStoreCouponState } from "~/types/store/coupon";

export function setCoupons(state: IStoreCouponState, value: ICartCouponData) {
    state.coupons = value.suggested.map<ICartSuggestedCoupon>((el) => ({
        code: el.code,
        details: el.details,
        priority: el.priority,
        variants: el.variants.map<ICartSuggestedCouponOption>((v) => {

            const date = v.activeTo ? new Date(v.activeTo) : null;
            const pTypes = v.payTypes?.length ? new Set(v.payTypes) : null;

            return {
                activeTo: date,
                discountTypes: v.discountTypes,
                id: v.id,
                minOrder: v.minOrder,
                payTypes: pTypes,
                suggestType: v.suggestType,
                value: v.value
            }
        })
    }));

    state.active = value.active;
}